// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2j9QI","buttons":"Footer_buttons__1MAUG"};